import React from "react";
import {fetchPageIfNeeded} from "../redux/actions";
import {connect} from "react-redux";

export function pageWithPrismic(WrappedComponent,
                                pageName,
                                additionalStateToProps = () => null,
                                additionalDataActions = []) {
  return connect(
    (state) => {
      return {
        page: state.pages[pageName],
        ...additionalStateToProps(state)
      };
    },
    (dispatch) => {
      return {
        fetchPage: (pageName) => {
          dispatch(fetchPageIfNeeded(pageName));
        },
        fetchData: () => {
          additionalDataActions.map(action => {
            dispatch(action());
          });
        },
        dispatch,
      };
    }
  )(class extends React.Component {
    constructor(props) {
      super(props);
    }

    componentDidMount() {
      this.props.fetchPage(pageName);
      this.props.fetchData();
    }

    render() {
      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
      return <WrappedComponent {...this.props} />;
    }
  });
}


// WEBPACK FOOTER //
// ./src/website-gridhaus/pageWithPrismic.js